var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.915C9.5 11.7434 10.1716 12.415 11 12.415C11.8284 12.415 12.5 11.7434 12.5 10.915V1.5C12.5 0.671573 11.8284 0 11 0C10.1716 0 9.5 0.671573 9.5 1.5V10.915Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.199989 11.533C-0.465305 16.1834 1.91898 20.738 6.11967 22.841C10.3204 24.9441 15.3954 24.124 18.72 20.805C21.1642 18.3784 22.3078 14.9336 21.8 11.527C21.2895 8.06074 19.1612 5.04373 16.067 3.40002C15.595 3.11389 15.0039 3.1101 14.5283 3.39017C14.0527 3.67024 13.7693 4.18891 13.7905 4.74047C13.8118 5.29204 14.1342 5.78737 14.63 6.03002C16.8922 7.22515 18.4514 9.4247 18.83 11.955C19.3189 15.3295 17.5914 18.6378 14.5429 20.1652C11.4944 21.6927 7.8103 21.0958 5.39999 18.684C3.62749 16.9251 2.79703 14.4282 3.16299 11.958C3.54093 9.42903 5.09906 7.23051 7.35999 6.03602C7.83701 5.78232 8.14074 5.29169 8.15512 4.75159C8.1695 4.21149 7.89231 3.70539 7.42946 3.42667C6.96661 3.14795 6.38963 3.13968 5.91899 3.40502C2.82927 5.05152 0.706276 8.06878 0.199989 11.533Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOff);
export default __webpack_public_path__ + "static/media/power-off.8b141a9a219be5df0d7a5665dbb0d6d9.svg";
export { ForwardRef as ReactComponent };